import * as React from 'react';

function Gymnastics(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M9.554 2v8.393a5.704 5.704 0 013.631 2.12 5.91 5.91 0 011.246 4.07 5.88 5.88 0 01-1.804 3.847A5.67 5.67 0 018.736 22a5.668 5.668 0 01-3.908-1.56 5.878 5.878 0 01-1.813-3.856 5.908 5.908 0 011.254-4.08 5.702 5.702 0 013.649-2.112V2h1.636zm-.818 10a4.052 4.052 0 00-2.892 1.22 4.207 4.207 0 00-1.198 2.947c0 1.105.431 2.164 1.198 2.946a4.052 4.052 0 002.892 1.22 4.052 4.052 0 002.892-1.22 4.207 4.207 0 001.198-2.946c0-1.105-.431-2.165-1.198-2.947A4.052 4.052 0 008.736 12zm6.543-5c.772 0 1.535.16 2.244.469.71.308 1.35.76 1.884 1.327.534.567.95 1.238 1.222 1.973a5.932 5.932 0 01-.183 4.569c-.332.71-.8 1.343-1.377 1.864a5.701 5.701 0 01-1.985 1.165 5.627 5.627 0 01-2.273.28A6.708 6.708 0 0015.229 17h.05c.7 0 1.387-.183 1.997-.53a4.125 4.125 0 001.489-1.457 4.233 4.233 0 00.16-4.066 4.143 4.143 0 00-1.368-1.574 4.024 4.024 0 00-3.981-.328 4.106 4.106 0 00-1.599 1.33 6.425 6.425 0 00-1.546-.65 5.77 5.77 0 012.08-2A5.64 5.64 0 0115.278 7zm.818-5v5h-1.636V2h1.636z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Gymnastics;
